import type { AccountConfigKey } from "@/types/account";

export function getTaskNameObject(taskOrTaskName: Record<string, any> | string) {
  if (typeof taskOrTaskName === "string") {
    const [category, type] = taskOrTaskName.split("/");
    const [key, ...namespace] = taskOrTaskName.split("/").reverse();
    return { namespace: namespace.reverse().join("/"), type, category, key };
  }
  if (typeof taskOrTaskName === "object") {
    const { namespace = "", key } = taskOrTaskName;
    const [category, type] = namespace.split("/");
    return { namespace, category, type, key };
  }
  return { namespace: "", category: "", type: "", key: "" };
}

export function getTaskRouteLink(
  task: Record<string, any> | string,
  linkType?: string | symbol
) {
  const { key, namespace, category, type } = getTaskNameObject(task);
  let query: any = {};
  const params: any = {};
  let name = RouteNames.SEARCH_TASKS;

  if (!namespace && key) {
    query["category"] = key;
  }

  if (category && !type && key) {
    query["category"] = category;
    query["type"] = key;
  }

  if (category && type && key) {
    params["category"] = category;
    params["type"] = type;
    params["key"] = key;
    query = {};
    name = RouteNames.CREATE_TASK_NEW;
  }

  if (linkType) {
    name =
      typeof linkType === "symbol"
        ? linkType
        : RouteNames[linkType as keyof typeof RouteNames] || name;
  }

  return { name, query, params };
}

export const taskKeyFeatureMap: Record<string, AccountConfigKey> = {
  "write-all-social": "canCreateTask.generateCrossPlatformSocialContent",
  "research-write-post": "canCreateTask.researchCraftYourPerfectArticle",
};

export function getTaskIconUrl(name: string) {
  return `https://assets.marketingassistant.com/images/icons/task-icons/${name}`;
}
